module.exports = __webpack_public_path__ + "img/law_pravicy.1be74857.jpg";